import Home from "./pages/home";
import PersonalRegistration from "./pages/personalRegistration";
import Registration from "./pages/registration";
import CollectiveRegistration from "./pages/collectiveRegistration";
import RegistrationCheck from "./pages/registrationCheck";
import NotFound from "./pages/NotFound";
import RegistrationCheckDetails from "./pages/registrationCheckDetails";
import Test from "./pages/personalRegistration/test";
import TestRegistration from "./pages/registration/test_registration";
import PersonalRegistrationTest from "./pages/personalRegistration/test";
import CollectiveRegistrationTest from "./pages/collectiveRegistration/test_collective";
import HomeTest from "./pages/home/home_test";
import RegistrationCheckTest from "./pages/registrationCheck/test";
import RegistrationCheckDetailsTest from "./pages/registrationCheckDetails/test";
const routeItem = (id, title, path, component) => {
  return {
    id,
    title,
    path,
    component,
  };
};

const routes = {
  home: routeItem(1, "Home", "/", HomeTest),
  // home_test: routeItem(11, "HomeTest", "/home-test", HomeTest),
  // personalRegistration: routeItem(
  //   2,
  //   "PersonalRegistration",
  //   "/personal-registration",
  //   PersonalRegistration
  // ),
  personalRegistration: routeItem(
    2,
    "PersonalRegistration",
    "/test-registration",
    PersonalRegistrationTest
  ),
  registration: routeItem(3, "Registration", "/registration", Registration),
  registration_test: routeItem(30, "RegistrationTest", "/registration-test", TestRegistration),
  // collectiveRegistration: routeItem(
  //   4,
  //   "CollectiveRegistration",
  //   "/collective-registration",
  //   CollectiveRegistration
  // ),
  collectiveRegistration: routeItem(
    4,
    "CollectiveRegistration",
    "/test-collective",
    CollectiveRegistrationTest
  ),
  registrationCheck: routeItem(
    5,
    "RegistrationCheck",
    "/registration-check",
    RegistrationCheck
  ),
  // registrationCheckTest: routeItem(
  //   6,
  //   "RegistrationCheckTest",
  //   "/registration-check-test",
  //   RegistrationCheckTest
  // ),
  RegistrationCheckDetails: routeItem(
    7,
    "RegistrationCheckDetails",
    "/registration-check-details",
    RegistrationCheckDetails
  ),
  // RegistrationCheckDetails: routeItem(
  //   7,
  //   "RegistrationCheckDetails",
  //   "/registration-check-details-test",
  //   RegistrationCheckDetailsTest
  // ),
  // Test: routeItem(7, "Test", "/test", Test),
  not_found: routeItem(404, "404", "*", NotFound),
};

const routeArr = Object.values(routes);

export { routes, routeArr };
